import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header style={{
      backgroundColor: '#222',
      color: '#fff',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
<h1 style={{ margin: 0 }}>
  <Link to="/">
    <img
      src="https://meshumimages.blob.core.windows.net/websiteimages/1.png"
      alt="Meshum Logo"
      style={{ height: '40px', objectFit: 'contain' }}
    />
  </Link>
</h1>

      <nav style={{ display: 'flex', gap: '1rem' }}>
        <Link to="/" style={{ color: '#fff' }}>Home</Link>
        {user?.email ? (
          <>
            <span style={{ color: '#aaa' }}>{user.email}</span>
            {user?.email && (
  <Link to="/saved" style={{ color: '#fff' }}>Saved Cars</Link>
)}
            <button
              onClick={handleLogout}
              style={{
                backgroundColor: '#444',
                color: '#fff',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login" style={{ color: '#fff' }}>Login</Link>
            <Link to="/register" style={{ color: '#fff' }}>Register</Link>
          </>
        )}
      </nav>
    </header>
  );
}

export default Header;
